import { css } from "@emotion/react"
import Cta from "../_control/Cta"
import { useIntl } from "react-intl"

/**
* @param {
* nextStepValid?: boolean,
* onPrevClick?: Function,
* onNextClick?: Function,   
* }
*/

export default function TabNavigator({ nextStepValid, onPrevClick, onNextClick }) {

    const { formatMessage } = useIntl()

    const showPrev = !!onPrevClick
    const showNext = !!onNextClick

    return <div css={css`
            margin-top: 2em;
            display: flex;
            justify-content: space-between;
            align-items: center;
        `}>
        {showPrev ?
            <Cta
                css={css`justify-self: flex-end;`}
                onClick={onPrevClick}
            >
                {formatMessage({ id: 'previous' })}
            </Cta>
            :
            <div ></div>
        }
        {showNext ?
            <Cta
                css={css`justify-self: flex-end;`}
                disabled={!nextStepValid}
                onClick={onNextClick}
            >
                {formatMessage({ id: 'next' })}
            </Cta>
            :
            <div ></div>
        }
    </div>
}